<template>
  <div
    ref="wrapper"
    class="item-form-wrapper"
  >
    <b-sidebar
      v-model="state"
      v-click-outside="onClickOutside"
      :width="`${width}px`"
      :no-header-close="true"
      right
      shadow
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="px-3 py-2">
        <data-table
          v-if="isReady"
          ref="dt"
          class="flex-grow-1 pt-2 text-nowrap"
          repo="users-leave"
          :parent-id="itemId"
          :fields="detailFields"
          :filter="filter"
          :order="order"
          :tbody-tr-class="getRowClass"
          :height="height"
          :limit="50"
        >
          <template #[`cell(user)`]="{ data }">
            <user-profile-item
              :user="data.item.user"
            />
          </template>
          <template #[`cell(created_at)`]="{ data }">
            <span v-shtml="$dateFormat(data.item.created_at, 'DD/MM/YYYY<br>HH:mm')" />
          </template>
          <template #[`cell(reason)`]="{ data }">
            <span v-if="data.item.reason === 'alt'">{{ data.item.motivation }}</span>
            <span v-else>{{ data.item.reason }}</span>
          </template>
        </data-table>
      </div>
      <template #header>
        <b-link v-if="isMobile" class="mr-2 text-info" @click="onCancel">
          <font-awesome-icon :icon="['fas', 'arrow-left']" class="mr-2" />
          <span v-shtml="parentTitle" />
          -
        </b-link>
        {{ displayTitle }}
        <span class="small ml-2">[{{ displayRange }}]</span>
      </template>
      <template #footer>
        <div
          ref="footer"
          class="d-flex bg-light align-items-center px-3 py-2"
        >
          <div />
          <strong class="mr-auto" />
          <b-btn variant="secondary" size="sm" :disabled="busy" @click="onCancel">
            {{ $t('eDoc_form_a_close') }}
          </b-btn>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { GlobalForm } from '~/mixins/globalForm'

const globalForm = GlobalForm('usersLeave', {})

export default {
  ...globalForm,
  name: 'UsersLeaveForm',
  props: {
    ...globalForm.props
  },
  data () {
    return {
      ...globalForm.data(),
      detailFields: [
        {
          key: 'user',
          label: 'User',
          sortable: true,
          thClass: 'col-3 text-center',
          class: 'text-left'
        },
        {
          key: 'created_at',
          label: 'Date',
          sortable: true,
          thClass: 'col-1 text-center',
          class: 'text-left',
          formatter: (value, key, item) => {
            return this.$dateFormat(value, 'DD/MM/YYYY<br>HH:mm')
          }
        },
        {
          key: 'reason',
          label: 'Motivation',
          sortable: false,
          thClass: 'col-5 text-center',
          class: 'text-left'
        }
      ],
      filter: [],
      order: {
        by: 'created_at',
        dir: 'desc'
      },
      isReady: false,
      height: 500
    }
  },
  computed: {
    ...globalForm.computed,
    ...mapGetters({
      deviceInfo: 'device',
      pageTitle: 'layout/pageTitle'
    }),
    isMobile () {
      return this.deviceInfo?.type === 'mobile' || false
    },
    displayTitle () {
      let title
      if (this.title) {
        title = this.title
      } else {
        title = `${this.displayUserType} leave motivation`
      }
      return title
    },
    displayUserType () {
      let type = 'Users'
      this.filter.forEach((i) => {
        if (i.column === 'user_type') {
          switch (i.value) {
            case 'client':
              type = 'Clients'
              break
            case 'hostess':
              type = 'Hostesses'
              break
          }
        }
      })
      return type
    },
    displayRange () {
      let from
      let to
      this.filter.forEach((i) => {
        if (i.column === 'date_from') {
          from = i.value
        }
        if (i.column === 'date_to') {
          to = i.value
        }
      })
      if (!from && to) {
        from = 'infinity'
      }
      if (from && !to) {
        from = 'now'
      }
      return `${from} - ${to}`
    },
    parentTitle () {
      return this.pageTitle ? this.$t(this.pageTitle) : ''
    }
  },
  watch: {
    ...globalForm.watch
  },
  mounted () {
    // Apply filters
    const existChainItem = this.getFromChain({ key: `${this.$options.name}.${this.itemId}` })
    if (existChainItem.length > 0 && existChainItem[0]?.options?.filter) {
      const optionsFilter = existChainItem[0].options.filter
      Object.keys(optionsFilter).forEach(key => this.filter.push({
        column: key,
        permanent: false,
        value: optionsFilter[key]
      }))
    }
    if (window) {
      window.addEventListener('resize', this.calcHeight)
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.calcHeight()
      }, 1000)
    })
    this.isReady = true
  },
  beforeDestroy () {
    if (window) {
      window.removeEventListener('resize', this.calcHeight)
    }
    // Flush related repos
    this.flush({ repo: 'users-leave', method: 'index' })
  },
  methods: {
    ...globalForm.methods,
    ...mapActions({
      fill: 'forms/usersLeave/fill'
    }),
    fillData () {
      if (this.itemRepo && this.itemRepo.id === this.itemId) {
        this.fill({
          id: this.itemId,
          data: {
            ...this.itemRepo,
            formData: this.formDataRepo
          }
        })
      }
    },
    flushData () {
      const existChainItem = this.getFromChain({ key: `${this.$options.name}.${this.itemId}` })
      if (existChainItem && existChainItem.length === 1) {
        // remove form from list
        this.removeForm(this.itemId)
      }
      // force go to index
      this.$nextTick(() => {
        window.history.pushState({}, '', '/')
      })
    },
    getRowClass (item) {
      const cls = ''
      return cls
    },
    calcHeight () {
      if (this.$refs.wrapper && window) {
        const $navbar = document.querySelector('.navbar')
        const navbarHeight = ($navbar && $navbar.clientHeight) || 0
        const windowHeight = window.innerHeight
        const footerHeight = (this.$refs.footer && this.$refs.footer.offsetHeight) || 0
        this.height = windowHeight - navbarHeight - footerHeight - 20
      }
    }
  }
}
</script>

<style scoped>

</style>
